import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import OptionAppResource from './OptionAppResource';
import WorkspaceTypeAppResource from './WorkspaceTypeAppResource';
import AnswerAppResource from './AnswerAppResource';

class S3RecorderImportAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 's3-recorder-import';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 's3s/recorders/imports';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'id',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {};
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {};
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {};
    }

}

export default S3RecorderImportAppResource;
